module.exports = "/static/assets/b8c58b160051ad14a948bce004de1f24.png";